import { Input } from '@/components/ui/input'
import { useUpdateTeam } from 'app/frontend/base/config/mutations'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useState } from 'react'
import { useTeam } from 'app/frontend/base/config/context/team'
import { useTranslation } from 'react-i18next'

const SheetsUrlInput = () => {
  const { team } = useTeam()
  const { t } = useTranslation()
  const { mutate } = useUpdateTeam(team)
  const [spreadsheetUrl, setSpreadsheetUrl] = useState(
    team.spreadsheetUrl ?? '',
  )
  const queryClient = useQueryClient()

  const handleSpreadsheetUrlBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const value = e.target.value.trim()
    if (value && !e.target.validity.valid) {
      toast.error(t('errors.invalid-spreadsheet-url'))
      setSpreadsheetUrl(team.spreadsheetUrl ?? '')
      return
    }

    mutate(
      { spreadsheetUrl },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: ['team', { path: team.path }],
          })
        },
      },
    )
  }
  return (
    <Input
      value={spreadsheetUrl}
      onChange={(e) => setSpreadsheetUrl(e.target.value)}
      type='url'
      className='my-2'
      placeholder='Paste this URL here: https://docs.google.com/spreadsheets/d/...'
      pattern='^https://docs\.google\.com/spreadsheets/d/[A-Za-z0-9_\-]+(?:/.*)?$'
      onBlur={handleSpreadsheetUrlBlur}
    />
  )
}

export default SheetsUrlInput
